import React, { useEffect } from 'react';
import { useAuth } from "../../services/AuthProvider";
import { useNavigate } from "react-router-dom";
import {Box, Typography} from "@mui/material";
import styles from "../Login/Login.module.css";
import EnvelopIcon from "../../resources/Login/envelope.png";
import SpiritImage from "../../resources/Login/password-spirit-image_0.png";
import SignUpBannerFooter from "../../components/Footer/SignUpBannerFooter";

const CheckYourEmail: React.FC = () => {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn) {
      navigate('/dashboard');
    }
  }, [isLoggedIn, navigate]);

  return (
    <div className={styles.Login} data-testid="check your email">
      <section id="CheckYourEmailTitle" className={styles.LoginTitle}>
        <Typography variant="h1">Check your email</Typography>
      </section>

      <br/><br/><br/>
      <Box sx={{ width: '80%', maxWidth: 800, textAlign: 'center' }}>
        <img src={EnvelopIcon} alt="envelop"/>
        <br/><br/><br/>
        <Typography variant="h3" gutterBottom>Check your email</Typography>
        <br/>
        <Typography variant="caption" gutterBottom>If the email address is registered, you will receive an email with a password reset link.</Typography>
        <br/><br/>
        <img src={SpiritImage} alt="spirit"/>
        <br/>

        <Typography variant="caption" gutterBottom>Didn’t receive the email? <a href="/forgot-password">Click to resend</a></Typography>
        <br/><br/>

        <button className={`PrimaryButton ${styles.LoginButton}`} onClick={() => navigate("/login")}>Back to login</button>
      </Box>

      <br/>
      <SignUpBannerFooter />
    </div>
  );
};

export default CheckYourEmail;
